import { render, staticRenderFns } from "./change_price.vue?vue&type=template&id=363602fb&"
import script from "./change_price.vue?vue&type=script&lang=js&"
export * from "./change_price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports